import React from 'react'
import {useTranslation} from '@wix/yoshi-flow-editor'
import {getPricingOption} from '@wix/wix-events-commons-statics'
import {LabelWithValue} from '../../../common/label-with-value'
import c from '../../../classnames.scss'
import {getPlaceInfoForOrderSummary} from '../../../../selectors/order-summary'
import {useCurrencyFormatter} from '../../../../../../../commons/hooks/currency'
import s from './place.scss'
import {PlaceProps} from './index'

export const Place = ({seatingPlan, ticket, seatId, priceOverride, pricingOptionId, currency}: PlaceProps) => {
  const {t} = useTranslation()
  const {section, element, area, table, place} = getPlaceInfoForOrderSummary(seatId, seatingPlan)
  const {getFormattedMoney} = useCurrencyFormatter()

  let price = Number(ticket.price.amount)
  let pricingOptionName: string
  if (priceOverride) {
    price = Number(priceOverride)
  } else if (pricingOptionId) {
    const pricingOption = getPricingOption(ticket, pricingOptionId)
    pricingOptionName = pricingOption.name
    price = Number(pricingOption.price.amount)
  }

  const labelWithValueClassNames = {
    valueClassName: c.formSummaryColor,
    labelClassName: c.formSummaryColor,
  }

  return (
    <div className={s.container}>
      <div className={s.infoContainer}>
        <LabelWithValue label={t('seatings_sector')} value={section.title} {...labelWithValueClassNames} />
        {area ? (
          <LabelWithValue label={t('seatings_area')} value={element.title} {...labelWithValueClassNames} />
        ) : (
          <div className={s.rowAndSeat}>
            <LabelWithValue
              label={table ? t('seatings_table') : t('seatings_row')}
              value={element.title}
              {...labelWithValueClassNames}
            />
            <LabelWithValue label={t('seatings_seat')} value={place.label} {...labelWithValueClassNames} />
          </div>
        )}
      </div>
      <div className={s.ticketInfoContainer}>
        {pricingOptionName ? (
          <div className={s.ticketInfoNameContainer}>
            <span>{ticket.name}</span>
            <span className={c.formSummaryColorSecondary}>{pricingOptionName}</span>
          </div>
        ) : (
          <span>{ticket.name}</span>
        )}
        <span>{getFormattedMoney({amount: price.toString(), currency})}</span>
      </div>
    </div>
  )
}
